import React from "react";
import { Box, Breadcrumbs, Grid, Link, Typography } from "@mui/material";

export default function AddInPayment() {
  return (
    <div>
      <Grid item xs={6}>
        <Box pt={2} pr={4} pl={4} pb={0}>
          <h5>Add-Ins/Services</h5>
        </Box>
        <div className="approval-basic-details">
          <div>
            <Breadcrumbs
              separator="›"
              aria-label="breadcrumb"
              className="distributor-breadcrumbs"
            >
              <Link
                underline="hover"
                color="inherit"
                to="/AddInsList"
                className="breadcrumb-title"
              >
                Integrations
              </Link>
              <Typography color="text.primary">Add-Ins/Services</Typography>
              <Typography color="text.primary">
                Add new Add-Ins/Services
              </Typography>
              <Typography
                color="text.primary"
                
              >
                Cart
               
              </Typography>
              
            </Breadcrumbs>
          </div>
         
        </div>
      </Grid>
      <Grid container xs={12} className="approval-separator">
        <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
          <Typography sx={{ fontWeight: "bold" }}>Shopping Cart</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: "bold" }}>Order Summary</Typography>
        </Grid>
      </Grid>
    </div>
  );
}
